import axios from "axios"

const controller = "/ordenPago"
const options = {
    headers: {
        "content-type": "application/json",
    }
}

const OrdenPagoService = {
    async registrar(request) {
        const { data } = await axios.post(`${controller}/registrar`, request)
        return data
    },
    async buscar(request) {
        const { data } = await axios.post(`${controller}/buscar`, request)
        return data
    },
    async obtener(request) {
        const { data } = await axios.post(`${controller}/obtener`, request)
        return data
    },
    async eliminar(request) {
        const { data } = await axios.post(`${controller}/eliminar`, request)
        return data
    },
    async modificar(request) {
        const { data } = await axios.post(`${controller}/modificar`, request)
        return data
    },
    async solicitarAprobacion(request) {
        const { data } = await axios.post(`${controller}/solicitarAprobacion`, request)
        return data
    },
    async aprobar(request) {
        const { data } = await axios.post(`${controller}/aprobar`, request)
        return data
    },
    async adjuntarPdf(file, opg_id) {
        let form = new FormData()
        form.append("file", file)
        form.append("opg_id", opg_id)
        const opts = { ...options }
        opts.headers["content-type"] = "multipart/form-data"
        const { data } = await axios.post(`${controller}/adjuntarPdf`, form, opts)
        return data
    },
}

export default OrdenPagoService